import { Fragment, Slice } from '@tiptap/pm/model'
import type { EditorView } from '@tiptap/pm/view'
import smartquotes from 'smartquotes'

export const stripAllMarksFromSlice = (slice: Slice, view: EditorView): Slice => {
  const sliceText = slice.content.textBetween(0, slice.content.size, '\r\n', ' ')
  if (!sliceText) return slice
  const text = smartquotes(sliceText)

  const textNode = view.state.schema.text(text)
  const newFragment = Fragment.from(textNode)
  return new Slice(newFragment, slice.openStart, slice.openEnd)
}
